// extracted by mini-css-extract-plugin
export default {"header":"ProvidersItemHeader_header__nluSQ","name":"ProvidersItemHeader_name__FPZ6B","customButton":"ProvidersItemHeader_customButton__xyA8b"};